export default {
  "Connect Wallet": 'เชื่อมต่อกระเป๋าเงิน',
  "Loading":"กำลังโหลด...",
  "Purchase Quantity": "จำนวนที่ซื้อ",
  "Total Amount": "จำนวนเงินรวม",
  "Payment Method": "วิธีการชำระเงิน",
  "Fee": "ค่าธรรมเนียม",
  "Purchase": "ซื้อ",
  "Select Payment Method": "เลือกวิธีการชำระเงิน",
  "Language Switch": "เปลี่ยนภาษา",
  "Mall": "ห้างสรรพสินค้า",
  "STAR Purchase": "ซื้อ STAR",
  "Order Details": "รายละเอียดคำสั่งซื้อ",
  "My Orders": "คำสั่งซื้อของฉัน",
  "Order Confirmation Page": "หน้ายืนยันคำสั่งซื้อ",
  "Product Details": "รายละเอียดสินค้า",
  "Store Details": "รายละเอียดร้านค้า",
  "Staking MUSE":"การปักหลัก MUSE",
  "My Stake":"คำมั่นสัญญาของฉัน",
  "Redeemable Time":"เวลาที่แลกได้",
  "Redeem":"ไถ่ถอน",
  "Stake":"จำนำ",
  "How to Obtain MUSE":"วิธีการได้มา MUSE",
  "Activity Rules":"กฎกติกากิจกรรม",
  "Stake Amount":"จำนวนเงินที่ระดมทุน",
  "Please Enter Amount":"กรุณากรอกจำนวนเงิน",
  "Balance":"ยอดคงเหลือ",
  "Redeem Amount":"จำนวนเงินที่ไถ่ถอน",
  "Confirm":"ยืนยัน",
  "Cancel":"ยกเลิก",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"Stake MUSE สามารถเพิ่มจำนวนโหวตสำหรับกิจกรรมแพลตฟอร์ม StarNest และโหวตให้กับผู้เล่นคนโปรดของคุณ",
  "Rule1": "1.เพิ่มน้ำหนักการโหวตของกิจกรรมแพลตฟอร์ม StarNest โดยการปักหลัก MUSE (โปรดดูคำอธิบายกิจกรรมที่เกี่ยวข้อง)",
  "Rule2": "2.MUSE ที่ให้คำมั่นสัญญาสามารถแลกรับได้ตลอดเวลาหลังจากกิจกรรมการลงทุนสิ้นสุดลง",
  "Rule3": "3.ด้วยการปักหลัก MUSE คุณสามารถมีส่วนร่วมในการกำกับดูแลแพลตฟอร์มและกิจกรรมอื่น ๆ ได้",
  "Rule4": "4.สิทธิ์ขั้นสุดท้ายในการตีความเป็นของแพลตฟอร์ม StarNest",
  "Staked":"เดิมพัน",
  "Redeemed":"แลกแล้ว",
  "Payment":"การชำระเงิน",
  "Next step":"ขั้นตอนถัดไป",
  "Amount":"จำนวน",
  "Copied":"คัดลอกแล้ว",
  "QRCodeTip":"โปรดสแกนโค้ด QR หรือคัดลอกที่อยู่เพื่อชำระเงินตามจำนวนคำสั่งซื้อ หากจำนวนเงินที่ชำระไม่เพียงพอ คำสั่งซื้อจะล้มเหลวและจะไม่มีการคืนเงินให้",
  "Scan QR code to pay":"สแกนรหัส QR เพื่อชำระเงิน",
  "DownloadTip":"สแกนโค้ด QR เพื่อดาวน์โหลดแอป StarNest และสัมผัสประสบการณ์ทันที",
  "Save QR code":"บันทึกคิวอาร์โค้ด",
  "Minimum":"ต่ำสุด",
  "All":"ทั้งหมด",
  "Failed to create order":"ไม่สามารถสร้างคำสั่งซื้อได้",
  "The order was created successfully and payment is being redirected":"สร้างคำสั่งซื้อสำเร็จแล้ว การชำระเงินกำลังถูกเปลี่ยนเส้นทาง",
  "Payment details":"ยอดชำระเงิน",
  "Address management":"จัดการที่อยู่",
  "New address":"สร้างที่อยู่ใหม่",
  "Delete address":"ลบที่อยู่",
  "Are you sure you want to delete this address?":"คุณแน่ใจหรือที่จะลบที่อยู่นี้",
  "First name":"นามสกุล",
  "Last name":"ชื่อ",
  "Please enter":"กรุณากรอก",
  "Phone":"หมายเลขโทรศัพท์",
  "Country":"ประเทศ",
  "State/Province":"รัฐ/จังหวัด",
  "City":"เมือง",
  "Address":"ที่อยู่",
  "Zip code":"รหัสไปรษณีย์",
  "Email":"อีเมล",
  "Save address":"บันทึกที่อยู่",
  "The address has been edited, do you want to save it?":"ที่อยู่ถูกแก้ไขแล้ว คุณต้องการบันทึกหรือไม่",
  "Return":"กลับ",
  "Save":"บันทึก",
  "Waiting for payment":"กำลังรอการชำระเงิน",
  "Please complete the payment within time as soon as possible":"กรุณาชำระเงินภายในเวลา{time}",
  "Expired":"หมดอายุ",
  "Order ID":"หมายเลขคำสั่งซื้อ",
  "Order total":"ยอดรวมคำสั่งซื้อ",
  "Order time":"เวลาสั่งซื้อ",
  "Payment method":"วิธีการชำระเงิน",
  "Billing address":"ที่อยู่สำหรับออกใบแจ้งหนี้",
  "Switch address":"เปลี่ยนที่อยู่",
  "Pay":"ยืนยันการชำระเงิน",
  "Deleted":"ลบแล้ว",
  "Please fill in the form completely":"กรุณากรอกแบบฟอร์มให้ครบถ้วน",
  "Create success":"สร้างสำเร็จ",
  "Update success":"แก้ไขสำเร็จ",
  "Insufficient balance":"ยอดเงินไม่เพียงพอ",
  "No address filled in yet":"ยังไม่ได้กรอกที่อยู่",
  "Choose country":"เลือกประเทศ",
  "Please enter search keywords":"โปรดป้อนคำหลักในการค้นหา",
  "Payment successful":"การชำระเงินสำเร็จ",
  "Please check the balance in your wallet":"โปรดตรวจสอบยอดเงินในกระเป๋าสตางค์ของคุณ",
  "Finish":"เสร็จสิ้น",
  "Payment failed":"การชำระเงินล้มเหลว",
  "Please complete the payment in time in My Order-Waiting for Payment":"โปรดชำระเงินภายในเวลาที่กำหนดในคำสั่งซื้อ - รอการชำระเงิน",
  "Uploading":"กำลังอัปโหลด",
  "Upload payment voucher":"อัปโหลดใบเสร็จการชำระเงิน",
  "Submission successful, please check the order later":"ส่งข้อมูลสำเร็จ กรุณาตรวจสอบคำสั่งซื้อในภายหลัง",
  "Confirm submission":"ยืนยันการส่ง",
  "Rate tip":"ตามวิธีการชำระเงินต่างๆ อาจมีความแตกต่างในอัตราแลกเปลี่ยนของราคา ตรงตามจำนวนเงินที่ชำระสุดท้าย",
  "Please log in":"กรุณาเข้าสู่ระบบ",
  "Insufficient product inventory":"สินค้าคงคลังไม่เพียงพอ",
  "Showtime":"เวลาแสดง",
  "Ticket file":"ไฟล์ตั๋ว",
  "Sold out":"ขายหมดแล้ว",
  "Limit tickets per order":"จำกัดตั๋วต่อการสั่งซื้อ {num} ใบ",
  "Please select region":"กรุณาเลือกพื้นที่",
  "Please fill in the correct email address":"กรุณากรอกอีเมลที่ถูกต้อง",
  "Delivery method":"วิธีการจัดส่ง",
  "E-ticket":"ตั๋วอิเล็กทรอนิกส์",
  "Direct entry":"เข้าชมโดยตรง",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"หลังจากชำระเงินสำเร็จ ไม่จำเป็นต้องรับตั๋ว สามารถไปที่โฟลเดอร์ตั๋วเพื่อตรวจสอบใบเสร็จเข้าชม",
  "Contact person":"ผู้ติดต่อ",
  "Name":"ชื่อ",
  "Please fill in the contact name":"กรุณากรอกชื่อผู้ติดต่อ",
  "Region":"พื้นที่",
  "Please enter the mobile number":"กรุณากรอกหมายเลขโทรศัพท์มือถือ",
  "Please fill in the email":"กรุณากรอกอีเมล",
  "The ticket verification code will be sent to your email via":"รหัสตรวจสอบตั๋วจะถูกส่งไปยังอีเมลของคุณ",
  "Details":"รายละเอียด",
  "Submit order":"ส่งคำสั่งซื้อ",
  "Price details":"รายละเอียดราคา",
  "The actual discount amount is subject to the following single page":"จำนวนส่วนลดที่แท้จริงขึ้นอยู่กับหน้าสั่งซื้อด้านล่าง",
  "Product information":"ข้อมูลสินค้า",
  "STAR deduction":"การหัก STAR",
  "Credit Card":"บัตรเครดิต",
  "Payment Platform":"แพลตฟอร์มการชำระเงิน",
  "On-Chain Payment":"การชำระเงินแบบออนเชน",
  "Other":"อื่นๆ",
  "No refunds":"ไม่สามารถคืนเงินได้",
  "Transferable":"โอนให้ได้",
  "Not transferable":"ไม่สามารถโอนให้ได้",
  "Ended":"สิ้นสุดแล้ว",
  "Countdown":"นับถอยหลัง",
  "Please select the ticket file":"โปรดเลือกไฟล์ตั๋ว",
  "Insufficient commodity inventory":"สินค้าคงคลังไม่เพียงพอ",
  "Please go to log in":"กรุณาเข้าสู่ระบบ",
  "Integral Mall":"ห้างสรรพสินค้าอินทิกรัล",
  "All Products":"สินค้าทั้งหมด",
  "Integral Records":"บันทึกแบบองค์รวม",
  "Transaction Details":"รายละเอียดธุรกรรม",
  "what": "MUSE คืออะไร?",
  "museIntro": "MUSE คือโทเคน ARC20 บน Armonia Meta Chain จำนวนรวม 2.1B 80% มาจากการขุดระบบนิเวศ",
  "museUse": "การใช้ MUSE",
  "copyrightStaking": "การ Staking ลิขสิทธิ์",
  "copyrightStaking1": "Stake MUSE ใน NFT ลิขสิทธิ์ศิลปิน (Metaverse AI, ภาพ ฯลฯ) เพื่อรับส่วนแบ่งรายได้",
  "vote": "การลงคะแนน",
  "vote1": "Stake MUSE เพื่อสิทธิ์ลงคะแนนพิเศษใน STAR NEST WAR",
  "product": "สินค้าพิเศษ",
  "product1": "ซื้อ NFT จำนวนจำกัด สินค้า ตั๋ว (early-bird/VIP)",
  "more": "ฟีเจอร์อื่นๆ (อัปเดต)",
  "more1": "GameFi: เกมที่ได้รับอนุญาติใช้ IP ศิลปิน ชำระด้วย MUSE",
  "more2": "สนับสนุนศิลปิน: ให้ทิปด้วย MUSE",
  "activity": "กิจกรรมพิเศษ",
  "activity1": "รับเชิญร่วมกิจกรรมส่วนตัว",
  "how": "วิธีรับ MUSE?",
  "how1": "ร่วม私募ระยะแรก",
  "how2": "สร้างคอนเทนต์รับรางวัล",
  "how3": "รับแอร์ดรอปผ่านกิจกรรม (ซื้อตั๋ว, ช้อปปิ้ง)",
  "how4": "ฟัง/ดูบางผลงานของ Audition แล้วรับรายได้ไปพร้อมกัน",
  "Redeem now":"แลกรับทันที",
  "Basic information":"ข้อมูลพื้นฐาน",
 }